












































































































































































































import Vue from "vue";

import NavigationButton from "@/components/NavigationButton.vue";
import DateInput from "../../../../components/DateInput.vue";
import store, { InterfaceStore } from "../../services/InterfaceStore";
import GeneralGetPurchaseInvoicesRequestDTO from "../../models/GeneralGetPurchaseInvoicesRequestDTO";

interface Data {
  store: InterfaceStore;
  showSendRequestConfirm: boolean;
  invNo: string;
  partnerCode: string;
  payMode: string;
  invDateFrom: Date | null;
  invDateTo: Date | null;
  accDateFrom: Date | null;
  accDateTo: Date | null;
  shipDateFrom: Date | null;
  shipDateTo: Date | null;
  ptermFrom: Date | null;
  ptermTo: Date | null;
  payDateFrom: Date | null;
  payDateTo: Date | null;
  apprDateFrom: Date | null;
  apprDateTo: Date | null;
}

interface Methods {
  sendRequest(): Promise<void>;
}

export default Vue.extend<Data, Methods, {}, {}>({
  name: "InvoiceRequestTool",

  components: {
    NavigationButton,
    DateInput,
  },

  data() {
    return {
      store,
      showSendRequestConfirm: false,
      invNo: "",
      partnerCode: "",
      payMode: "",
      invDateFrom: null,
      invDateTo: null,
      accDateFrom: null,
      accDateTo: null,
      shipDateFrom: null,
      shipDateTo: null,
      ptermFrom: null,
      ptermTo: null,
      payDateFrom: null,
      payDateTo: null,
      apprDateFrom: null,
      apprDateTo: null,
    };
  },

  methods: {
    /**
     * Az összeállított szűrési feltételek elküldése lekérdezésként az aktuális interfészre.
     * A mezőkből felépíti a GeneralGetPurchaseInvoicesRequestDTO-t (a UserId-t a backend tölti a
     * bejelentkezett felhasználóval), és a store `customDownSyncInterface`-én keresztül elküldi.
     */
    async sendRequest() {
      const request: GeneralGetPurchaseInvoicesRequestDTO = {
        invNo: this.invNo || null,
        partnerCode: this.partnerCode || null,
        payMode: this.payMode || null,
        invDate: { fromDate: this.invDateFrom, toDate: this.invDateTo },
        accDate: { fromDate: this.accDateFrom, toDate: this.accDateTo },
        shipDate: { fromDate: this.shipDateFrom, toDate: this.shipDateTo },
        pterm: { fromDate: this.ptermFrom, toDate: this.ptermTo },
        payDate: { fromDate: this.payDateFrom, toDate: this.payDateTo },
        apprDate: { fromDate: this.apprDateFrom, toDate: this.apprDateTo },
        pageSize: 50,
      };

      try {
        await this.store.customDownSyncInterface(request);
        this.showSendRequestConfirm = false;
        this.store.showRequestTool = false;
      } catch (e) {
        console.error(e);
      }
    },
  },
});
